import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonComponent, CallToActionResponse } from '@woolworthsnz/styleguide';
import { CarouselElementComponent, GridComponent } from '@woolworthsnz/product';
import { ProductResponse } from '@woolworthsnz/trader-api';
import { RouterLink } from '@angular/router';
import { NgIf, NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
	selector: 'dc-carousel',
	template: `
		<ng-container *ngIf="products?.length > 0">
			<h2
				class="heading--withChild"
				[ngClass]="{ 'visible-phone': titleIsMobileOnly, grid: displaytype === 'grid' }"
				*ngIf="title"
			>
				{{ title }}
				<ng-container *ngTemplateOutlet="headerLink"></ng-container>
			</h2>

			<ng-template #headerLink>
				<a *ngIf="hero?.action.link" inline="true" class="visible-phone" cdxButton [routerLink]="hero?.action.link">{{
					hero?.action.title || 'See all'
				}}</a>
			</ng-template>

			<ng-container *ngIf="displaytype === 'carousel'; then carouselTemplate; else gridTemplate"></ng-container>

			<ng-template #carouselTemplate>
				<product-carousel
					[hero]="hero"
					[name]="name"
					[title]="title"
					[products]="products"
					[isshopper]="isshopper"
					[isloggedin]="isloggedin"
					[analyticsID]="analyticsID"
				></product-carousel>
			</ng-template>
			<ng-template #gridTemplate>
				<product-grid
					[products]="products"
					[title]="title"
					[isshopper]="isshopper"
					[isloggedin]="isloggedin"
				></product-grid>
			</ng-template>
		</ng-container>
	`,
	styleUrls: ['./carousel.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf, NgClass, NgTemplateOutlet, ButtonComponent, RouterLink, CarouselElementComponent, GridComponent]
})
export class CarouselComponent {
	@Input() name: string;
	@Input() title: string;
	@Input() productGroupId: string;
	@Input() titleIsMobileOnly: boolean;
	@Input() displaytype: 'grid' | 'carousel';
	@Input() cta: CallToActionResponse;
	@Input() hero: CallToActionResponse;
	@Input() isloggedin: boolean;
	@Input() isshopper: boolean;
	@Input() analyticsID: string;

	@Input() products: (CallToActionResponse | ProductResponse)[];
}
